import axiosPrivate from "../../../api/axiosPrivate";
import { OFFICE_URL, SEARCH_OFFICE } from "./../../../api/constant";

// Get all offices
const fetchAllOffices = async (data) => {
  const response = await axiosPrivate.get(
    `${OFFICE_URL}?office_id=${data?.office_id}&page=${data?.pageNumber}`
  );
  return response.data;
};

// Get Single Office
const fetchSingleOffice = async (id) => {
  const response = await axiosPrivate.get(`${OFFICE_URL}/${id}`);
  return response.data;
};

// Create New Office
const addNewOffice = async (officeData) => {
  const response = await axiosPrivate.post(`${OFFICE_URL}`, officeData);
  return response.data;
};
// Update Office
const updateOffice = async (officeData) => {
  let officeId = officeData.officeId;
  const response = await axiosPrivate.put(
    `${OFFICE_URL}/${officeId}`,
    officeData
  );
  return response.data;
};

//search user
const searchOffices = async (data) => {
  const response = await axiosPrivate.get(
    `${SEARCH_OFFICE}?office_id=${data.office_id}&search=${data.searchText}`
  );
  return response.data;
};

// Paginate Offices
// const fetchData = async (pageNumber = 1) => {
//     const api = await fetch(`http://127.0.0.1:8000/api/offices?page=${pageNumber}`);
//     setCurrentOffices({
//         currentOffices: await api.json()
//     });
// };

const officeService = {
  fetchAllOffices,
  fetchSingleOffice,
  addNewOffice,
  updateOffice,
  searchOffices,
};

export default officeService;
